module.exports = __webpack_public_path__ + "static/media/0-1.6888cc77.svg";